var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatResilience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277.28 314.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:30px;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.62,14.46,15,49.64V169.21c16.73,54.35,67.09,111,127.62,131.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.66,14.46,262.28,49.64V169.21c-16.73,54.35-67.08,111-127.62,131.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.62,30.44V300.37s89.82-47.72,114.24-131.16,0-119.57,0-119.57L140.62,14.46Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatResilience);
export default __webpack_public_path__ + "static/media/stat-resilience.04d11fcdfb4054e4080dd410626a4ad5.svg";
export { ForwardRef as ReactComponent };